import { EMPTY_OBJECT } from "lib";
import { omit } from "lodash";

export const toggleRecipientReducer = (state, action) => {
  const {
    billingDocumentId,
    businessUser,
    emailRecipient,
    rawEmailAddress,
    add,
    remove,
  } = action;

  const existingDocumentState = state[billingDocumentId] || EMPTY_OBJECT;

  if (add || remove) {
    // Handle re-init / user selecting more documents to dispatch.
    const newState = {
      ...state,
      ...add,
    };
    return omit(newState, remove);
  }

  const businessUsers = businessUser
    ? (() => {
        const existing = existingDocumentState.businessUsers || [];
        const hasId = existing.some(bu => bu.id === businessUser.id);
        return hasId
          ? existing.filter(bu => bu.id !== businessUser.id)
          : [...existing, businessUser];
      })()
    : existingDocumentState.businessUsers;

  const emailRecipients = emailRecipient
    ? (() => {
        const existing = existingDocumentState.emailRecipients || [];
        const hasId = existing.some(er => er.id === emailRecipient.id);
        return hasId
          ? existing.filter(er => er.id !== emailRecipient.id)
          : [...existing, emailRecipient];
      })()
    : existingDocumentState.emailRecipients;

  return {
    ...state,
    [billingDocumentId]: {
      ...existingDocumentState,
      businessUsers,
      emailRecipients,
      rawEmailAddress:
        "rawEmailAddress" in action
          ? rawEmailAddress
          : existingDocumentState.rawEmailAddress || "",
    },
  };
};
